module.exports = __webpack_public_path__ + "html/success-stories-list-item_6f9b6a4f80fd1c8dd3b9e1f135ff10ce.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/success-stories-list-item.html
// module id = akPD
// module chunks = 50